import type { PumpStatus } from "@tandemdiabetes/sugarmate-api-react-client"
import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import {
  forwardRef,
  useMemo,
} from "react"

import { isBatteryLow } from "./isBatteryLow"
import styles from "./PumpStatus.module.scss"

import { usePolyglot } from "src/contexts"
import { DataRecency } from "src/types"
import { round } from "src/utils"

export interface Props extends ComponentPropsWithoutRef<"div"> {
  pumpStatus: PumpStatus;
  pumpStatusRecency: DataRecency;
}

export const PumpBatteryPercentage = forwardRef<HTMLDivElement, Props>(
  function PumpBatteryPercentage(props: Props, propRef: Ref<HTMLDivElement>) {
    const {
      pumpStatus,
      pumpStatusRecency,
      ...divProps
    } = props

    const { battery_percent: batteryPercent } = pumpStatus

    const polyglot = usePolyglot()

    const batteryPercentString: string = useMemo(
      () => {
        if (batteryPercent === null || pumpStatusRecency === DataRecency.Stale) {
          return "---"
        }

        return polyglot.t(
          "unit.percentage",
          { value: round(batteryPercent).toLocaleString(polyglot.locale()) },
        )
      },
      [
        polyglot,
        batteryPercent,
        pumpStatusRecency,
      ],
    )

    const lowBattery = isBatteryLow(
      batteryPercent,
      pumpStatusRecency,
    )

    return (
      <div
        {...divProps}
        className={classNames(
          divProps.className,
          lowBattery && styles.lowText,
        )}
        ref={propRef}
      >
        {batteryPercentString}
      </div>
    )
  },
)
